'use strict'

function UiHfSelect () {
  return {
    templateUrl: 'app/directives/uiHfSelect/uiHfSelect.html',
    restrict: 'AE',
    require: '?ngModel',
    scope: {
      form: '=',
      name: '@',
      label: '@',
      atrmodel: '@',
      atrlabel: '@',
      ngModel: '=',
      change: '=',
      required: '=',
      disabled: '=',
      list: '=',
      placeholder: '@',
      col: '@'
    }
  }
}

angular.module('app').directive('uiHfSelect', UiHfSelect)



//////////////////
// WEBPACK FOOTER
// ./directives/uiHfSelect/uiHfSelect.directive.js
// module id = 90
// module chunks = 0